<template>
  <div class="form-content-quick">
    <el-input type="textarea" class="gourney-follow-text" ref="followContentRef" v-model="content" placeholder="请输入跟进内容..." :rows="4" maxlength="300" :show-word-limit="true" @input="handleInput" @focus="handleFocus" @blur="handleBlur"></el-input>
    <span class="quick-btn" @click="handleQuick">！快速录入</span>
    <div class="result-list" v-if="isShowQuickTab" >
      <template v-if="quicklyMenu">
        <p @click="handleSelect(`！${item}`,'custom', key)" v-for="(item ,key) in quicklyMenu.customList" :key="'custom'+key">
          <span v-if="preInsert == item" class="pre-insert-dom"><i class="iconfont">&#xe64e;</i>上次录入</span>
          ！{{item}}
        </p>
        <p @click="handleSelect(`！${item}`,'label', key)" v-for="(item ,key) in quicklyMenu.customer_label" :key="'label_'+key">
          ！{{item}}
        </p>
        <p @click="handleSelect(`！客户等级为${item}`,'level', key)" v-for="(item ,key) in quicklyMenu.customer_levels_for_create" :key="'level_'+key">
          ！客户等级为{{item}}
        </p>
        <p @click="handleSelect(`！${item}`,'room_id', key)" v-for="(item ,key) in quicklyMenu.rooms" :key="'room_id_'+key">
          ！{{item}}
        </p>
        <p @click="handleSelect(`！${item}`,'house_type', key)" v-for="(item ,key) in quicklyMenu.house_types" :key="'house_type_'+key">
          ！{{item}}
        </p>
        <p @click="handleSelect(`！${item.name}`,'area', key,item)" v-for="(item ,key) in quicklyMenu.areaList" :key="'area_'+key">
          ！{{item.name}}
        </p>
        <p @click="handleSelect(`！${item.name}`,'price', key,item)" v-for="(item ,key) in quicklyMenu.priceList" :key="'price_'+key">
          ！{{item.name}}
        </p>
      </template>
      <span class="none-info" v-else>未匹配到信息。输入空格可以记录已输入内容哦</span>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import PopoverRight from '@/components/popover/index';
const quicklyMenuTxt = [
  '刚需房', '学区房', '改善房', '置换房', '近地铁', '已加微信',
  '客户等级为A', '客户等级为B', '客户等级为C', '客户等级为D', 
  '1居', '2居', '3居', '4居', '5居及以上',
  '50㎡以下', '50 - 70㎡', '70 - 90㎡', '90 - 110㎡', '110 - 130㎡', '130 - 150㎡', '150㎡以上',
  '40 万以下', '40-60 万', '60-80 万', '80-100 万', '100-150 万', '150-200 万', '200 万以上'
]
export default{
  name: 'FollowContent',
  props: {
    model_content: String,
  },
  data () {
    return {
      content: '',
      isShowQuickTab: false,
      quickList: '',
      preInsert: '', // 上次录入内容
      quicklyMenu:{
        customList:{},//自定义
        areaList: [
          {id: 1, name: '50㎡以下', min: '', max: 50},
          {id: 2, name: '50-70㎡', min: 50, max: 70},
          {id: 3, name: '70-90㎡', min: 70, max: 90},
          {id: 4, name: '90-110㎡', min: 90, max: 110},
          {id: 5, name: '110-130㎡', min: 110, max: 130},
          {id: 6, name: '130-150㎡', min: 130, max: 150},
          {id: 7, name: '150㎡以上', min: 150, max: ''}
        ],
        priceList: [
          {id: 1, name: '40万以下', min: '', max: 40},
          {id: 2, name: '40-60万', min: 40, max: 60},
          {id: 3, name: '60-80万', min: 60, max: 80},
          {id: 4, name: '80-100万', min: 80, max: 100},
          {id: 5, name: '100-150万', min: 100, max: 150},
          {id: 6, name: '150-200万', min: 150, max: 200},
          {id: 7, name: '200万以上', min: 200, max: ''}
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.user.userInfo
    })
  },
  async created() {
    const configKey = await this.$store.dispatch('initConfig', ['customer_levels_for_create','customer_label', 'house_types', 'customer_qualifications', 'customer_locations', 'rooms']);
    this.quicklyMenu ={
      ...configKey,
      ...this.quicklyMenu
    }
    this.content = this.model_content || '';
  },
  methods: {
    handleInput (val) {
      this.dealResult(val, true);
    },
    handleFocus () {
      this.dealResult(this.content, false);
    },
    dealResult (val, isDeal) {
      // 获取最后一段！输入的内容
      const index = val.lastIndexOf('！');
      if (index < 0) {
        this.isShowQuickTab = false;
        return null;
      }
      // 包含！且不以空格结尾的拉起快捷弹窗
      const data = val.substring(index);
      if (/^！\S{0,}\s+/.test(data)) {
        this.isShowQuickTab = false;
        // 保存为快捷标签
        if (isDeal) {
          this.dealCacheTag(data);
        }
        return null;
      }
      // 获取匹配最新的内容
      const cacheList = JSON.parse(localStorage.getItem('customeDetailFollowTags') || '{}');
      const list = cacheList[this.userInfo.id] || [];
      const origins = [ ...list,...quicklyMenuTxt];
      this.preInsert = list[0];
      // 判断是否需要过滤
      const _data = data.substring(1);
      this.quicklyMenu.customList = list;
      // if (_data && _data != '') {
      //   var aaa =  origins.filter(v => {
      //     return v.indexOf(_data) >= 0;
      //   })
      //   console.log(aaa)
      //   // this.quickList = origins.filter(v => {
      //   //   return v.indexOf(_data) >= 0;
      //   // })
      // } else {
      //   this.quicklyMenu.customList = list;
      // }
      this.isShowQuickTab = true;
    },
    // 判断是否是自定义标签，且保存
    dealCacheTag (val) {
      if (!/^！\S{0,}\s$/.test(val)) return null;
      const data = val.substring(1, val.indexOf(' '));
      // 判断是否是固定标签
      const isExits = quicklyMenuTxt.indexOf(data) >= 0;
      if (isExits) return null;
      // 判断是否存在缓存里面
      const cacheList = JSON.parse(localStorage.getItem('customeDetailFollowTags') || '{}');
      const uid = this.userInfo.id;
      const list = cacheList[uid] || [];
      if (list.length > 0) {
        const index = list.indexOf(data);
        if (index >= 0) {
          list.splice(index, 1);
        }
        if (list.length > 100) {
          list.splice(0, 1);
        }
      }
      list.unshift(data);
      localStorage.setItem('customeDetailFollowTags', JSON.stringify({...(cacheList || {}), [uid]: list}));
    },
    handleBlur (e) {
      // 延迟处理失焦以后快捷筛选内容无法点击bug
      setTimeout(() => {
        if (this.currentOpe > 0) return null;
        this.isShowQuickTab = false;
      }, 300);
      // 传递内容
      this.$emit('update:model_content', this.content);
    },
    handleSelect (val,label,key,item) {
      const multiple = ['label','house_type','room_id']
      if(label == 'level'){
        this.$emit('handleSingleSet',label,key,false)
      }
      if(label == 'area' || label == 'price'){
        this.$emit('handleChangeType',item,label,false)
      }
      if(multiple.indexOf(label) > -1){
        this.$emit('handleMutipleSet',label,key,false)
      }
      this.currentOpe = 1;
      const data = this.content;
      // 获取两端匹配的内容
      const index = data.lastIndexOf('！');
      const lastData = data.substring(index);
      const preData = data.substring(0, index);
      // 替换后半段需要匹配的内容
      this.content = `${preData}${val} `;
      // 传递内容
      this.$emit('update:model_content', this.content);
      // 隐藏快捷筛选框
      this.isShowQuickTab = false;
      setTimeout(() => {
        this.currentOpe = -1;
      }, 300);
    },
    handleQuick () {
      // 已经在快速录入的状态下不需要拉起
      if (this.isShowQuickTab) return null;
      this.currentOpe = 1;
      this.$refs.followContentRef.focus();
      // 拼接！且拉起快选
      this.content = `${this.content}！`;
      this.$nextTick(_ => {
        this.dealResult(this.content);
      })
      setTimeout(() => {
        this.currentOpe = -1;
      }, 300);
    },
    clear () {
      this.content = '';
    }
  },
}
</script>
<style lang="less" scoped>
.form-content-quick{
  position: relative;
  padding-bottom: 45px;
  .result-list{
    width: 370px;
    max-height: 270px;
    background: #FFFFFF;
    border: 1px solid #E8E8E8;
    box-shadow: 0px 3px 8px 0px rgba(0,0,0,0.28);
    border-radius: 3px;
    position: absolute;
    left: 105px;
    top: 105px;
    color: #333333;
    font-size: 12px;
    z-index: 999999;
    padding: 10px 20px;
    line-height: 20px;
    overflow-y: scroll;
    .scrollbar(5px);
    p{
      padding: 4px 0;
      cursor: pointer;
      pointer-events: auto;
      &:hover{
        color: #3168FF;
      }
    }
  }
  .quick-btn{
    position: absolute;
    top: 128px;
    left: 0;
    background: #F4F4F4;
    cursor: pointer;
    user-select: none;
    width: 90px;
    height: 30px;
    line-height: 30px;
    color: #666666;
    font-size: 12px;
    text-align: center;
    border-radius: 3px;
    top: 105px;
  }
  .pre-insert-dom{
    font-size: 12px;
    display: inline-block;
    color: #999;
    .iconfont{
      vertical-align: -2px;
    }
  }
  .none-info{
    font-size: 12px;
    text-align: center;
    color: #999;
    display: block;
  }
}
</style>
<style lang="less">
.form-content-quick .gourney-follow-text .el-textarea__inner{
  resize: none;
}
</style>